import { Head } from '@ecommerce/nest-ssr/components';
import favicon from 'assets/images/favicon.svg';
import AdConfig from 'components/ads/ad-config';
import DataLayer from 'components/datalayer/datalayer';
import Environment from 'components/environment';
import GtmBody from 'components/gtm/gtm-body';
import GtmHead from 'components/gtm/gtm-head';
import { useSeo } from 'hooks/use-seo';
import React from 'react';
import { Modals } from 'components/modal/modals';
import IbCookieHandler from 'components/cookies/ib-cookie-handler/ib-cookie-handler';
import PartnerCookieHandler from 'components/cookies/partner-cookie-handler/partner-cookie-handler';

import './main-layout.base.scss';

const MainLayout: React.FC = ({ children }) => {
    const seo = useSeo();
    const gtmKey = 'VHBV';

    return (
        <>
            <Head>
                <meta charSet="UTF-8"/>
                <meta name="theme-color" content="#084691"/>
                <meta name="google-site-verification" content="SgZoNTXyE1lCIQ3ofknKo9z3Exa8gLkSA7wgJeuzzFg"/>
                <link rel="shortcut icon" href={favicon}/>
                <link rel="manifest" href="/manifest.json?v1.0.1"/>
                <title>
                    {seo.title}
                </title>
                <meta name="keywords" content={seo.keywords}/>
                <meta name="description" content={seo.description}/>

                <meta property="og:title" content={seo.title}/>
                <meta property="og:locale" content="pl_PL"/>
                <meta property="og:description" content={seo.description}/>
                <meta property="og:url" content={`https://www.skapiec.pl${seo.og.url}`}/>
                <meta property="og:site_name" content="Skapiec.pl"/>
                <meta property="fb:pages" content="109945222777"/>
                <meta name="image" property="og:image" content={seo.og.image}/>
                <meta property="og:type" content={seo.og.type}/>
                <link rel="canonical" href={seo.canonical}/>
                <link href="https://fonts.gstatic.com/" crossOrigin="anonymous" rel="preconnect"/>
                <AdConfig/>
                <GtmHead gtmKey={gtmKey}/>
            </Head>
            {children}
            <Modals/>
            <GtmBody gtmKey={gtmKey}/>
            <DataLayer/>
            <Environment/>
            <IbCookieHandler/>
            <PartnerCookieHandler />
            <script
                dangerouslySetInnerHTML={{
                    __html: 'if(navigator.userAgent.indexOf("MSIE ") > -1 '
                        + '|| navigator.userAgent.indexOf("Trident/") > -1) '
                        + '{var elem = document.createElement("div"); '
                        + 'var a = document.createElement("a"); a.href="/zalecane-przegladarki"; '
                        + 'var text = document.createTextNode("Sprawdź jakie przeglądarki zapewnią '
                        + 'Ci pełne bezpieczeństwo i wygodę korzystania z naszego serwisu");'
                        + ' a.appendChild(text);elem.style.cssText = "width: 100%; height: 50px;'
                        + ' background: orange; color: white; display: flex; align-items: center;'
                        + ' justify-content: center;"; elem.innerText = "Używasz przestarzałej przeglądarki.";'
                        + ' elem.appendChild(a); document.body.insertBefore(elem, document.body.firstChild);'
                        + ' dataLayer.push({"not-supported-browser-bar": 1});}'
                }}
            />
        </>
    );
};

export default React.memo(MainLayout) as React.FC;
